<div class="card-container-shadow "> <!-- tw-h-full -->
  <div class="left-line">

  </div>
  <div class="name">
    <p class="text-title-md text-bold mr-xs" nz-popover="" nzPopoverTitle="" [nzPopoverContent]="mealPlan.name">{{ mealPlan.name }}</p>
    <div class="more-options" *ngIf="!cardToAssign">
      <div *ngIf="!mealPlan.official" nz-popover="" nzPopoverTitle="" nzPopoverContent="Modificar" class="icon-action tw-mr-2" (click)="onEmitEdit()">
        <i nz-icon nzType="edit" nzTheme="outline"></i>
      </div>
      <div *ngIf="mealPlan.official" nz-popover="" nzPopoverTitle="" nzPopoverContent="Los planes de alimentación originales Dèliè no se pueden modificar ni eliminarse, solo pueden duplicarse." class="icon-action tw-mr-2">
        <i nz-icon nzType="info-circle" nzTheme="outline"></i>
      </div>
      <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Duplicar" class="icon-action tw-mr-2" (click)="onEmitClone()">
        <i nz-icon nzType="copy" nzTheme="outline"></i>
      </div>
      <div *ngIf="!mealPlan.official" nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="icon-action danger" (click)="onEmitDelete()">
        <i nz-icon nzType="delete" nzTheme="outline"></i>
      </div>
    </div>
    <div class="more-options" *ngIf="cardToAssign">
      <div class="icon-action action-assign shepherd-button-select" (click)="onEmitAssignTo()">
        <i nz-icon nzType="check-square" nzTheme="outline" class="tw-mr-2"></i>
        Ver este plan
      </div>
    </div>
  </div>
  <p
    class="text-info mt-xxs pr-xlg"
    nz-popover=""
    [nzPopoverTrigger]="this.mealPlan.instructions.length > 30 ? 'click' : null"
    nzPopoverPlacement="topLeft"
    nzPopoverTitle="Instrucciones"
    [nzPopoverContent]="moreDetailsTpl"
    appExpandText
    maxCharacters="30"
    onlyTruncate="true">
    {{ mealPlan.instructions || 'no hay instrucciones.'}}
  </p>

  <div class="categories mt-xxs">
    <img loading="lazy" class="mr-xs" src="./../../../assets/images/icons/icons8-etiqueta-de-precio-100.png" alt="">
    <div class="text-subtitle" *ngIf="mealPlan?.tags?.length> 0">
      <app-concat-properties [truncate]="true" [data]="mealPlan?.tags" subfixSingular="categoría más" subfixPlural="categorías
        más"></app-concat-properties>
    </div>
    <div class="text-subtitle" *ngIf="mealPlan?.tags?.length === 0">
      No hay categorías relacionadas
    </div>
  </div>

  <div class="tags mt-xs" *ngIf="false">
    <span class="tag-small tag-green">
      keto
    </span>
  </div>
  <p class="text-regular-14 mt-xs tw-font-semibold">Periodos</p>
  <div class="text-subtitle mt-xxs">
    <app-concat-properties [truncate]="true" [maxItems]="3" [propertyName]="'name'" [data]="mealPlan.planPeriods" subfixSingular="periodo
      más"
      subfixPlural="periodos más"></app-concat-properties>
  </div>

  <p class="text-info tw-mt-3">Macronutrientes por periodo.</p>
  <div class="macros d-flex justify-content-between tw-my-2" *ngIf="this.mealPlan.planPeriods"> <!-- mb-md -->
    <div class="macro">
      <img loading="lazy" src="./../../../assets/images/icons/icons8-chocolatina-100.png" alt="">
      <p class="text-info-bold-xs mb-xxs opacity-70">Calorías</p>
      <p class="text-info text-bold">{{ Math.floor((mealPlan?.nutritionalProperties?.energy_kcal || 0) / mealPlan.planPeriods.length) }} kcal</p>
    </div>
    <div class="macro">
      <img loading="lazy" src="./../../../assets/images/icons/icons8-sunny-side-up-huevos-100.png" alt="">
      <p class="text-info-bold-xs mb-xxs opacity-70">Grasas</p>
      <p class="text-info text-bold">{{ ((mealPlan?.nutritionalProperties?.totalFat_g || 0) / mealPlan.planPeriods.length)?.toFixed(2) }} g</p>
    </div>
    <div class="macro">
      <img loading="lazy" src="./../../../assets/images/icons/icons8-pastel-de-nata-100.png" alt="">
      <p class="text-info-bold-xs mb-xxs opacity-70">Carbohidratos</p>
      <p class="text-info text-bold">{{ ((mealPlan?.nutritionalProperties?.carbohydrate_g || 0) / mealPlan.planPeriods.length)?.toFixed(2) }} g</p>
    </div>
    <div class="macro">
      <img loading="lazy" src="./../../../assets/images/icons/icons8-jamon-100.png" alt="">
      <p class="text-info-bold-xs mb-xxs opacity-70">Proteínas</p>
      <p class="text-info text-bold">{{ ((mealPlan?.nutritionalProperties?.protein_g || 0) / mealPlan.planPeriods.length)?.toFixed(2) }} g</p>
    </div>
    <div class="macro">
      <img loading="lazy" src="./../../../assets/images/icons/icons8-heno-100.png" alt="">
      <p class="text-info-bold-xs mb-xxs opacity-70">Fibra</p>
      <p class="text-info text-bold">{{ ((mealPlan?.nutritionalProperties?.dietaryFiber_g || 0) / mealPlan.planPeriods.length)?.toFixed(2) }} g</p>
    </div>
  </div>

  <nz-divider></nz-divider>
  <div class="tw-mt-2 d-flex tw-flex-col" *ngIf="mealPlan.expert"> <!-- mt-xlg -->
    <div class="tw-flex tw-items-center tw-justify-between">
      <div class="tw-flex tw-items-center tw-w-2/3">
        <div class="">
          <app-avatar-user [image]="mealPlan.expert.profileImageURL" [name]="mealPlan.expert.name" [lastname]="mealPlan.expert.lastname" [width]="35"></app-avatar-user>
        </div>
        <div class="ml-xs tw-w-full">
          <span class="text-info-bold-xs opacity-70">Autor</span>
          <p class="text-info-sm text-bold truncate author-name">{{ getAuthorMealPlanName }}
        </div>
      </div>
      <p class="delie-verified tw-w-1/3 text-end" nz-popover="" nzPopoverTitle="" [nzPopoverContent]="'Este plan de alimentación es original de Dèliè Nutrición'" *ngIf="mealPlan.official">
        <img src="/assets/images/icons/verified-delie.png" alt="" class="icon">
        <span class="text">Dèliè oficial</span>
      </p>
    </div>
  </div>

<ng-template #moreDetailsTpl>
  <div class="flex" style="width: 500px">
    <div class="flex-1">
      {{ mealPlan.instructions }}
    </div>
  </div>
</ng-template>
</div>
